import React from 'react'
import { Text, View, TouchableOpacity, Image } from 'react-native'
import styles from '../ScheduleStyles'

interface RetryComponentProps {
    onRefresh: (value: boolean) => void
    textButton: string
    title: string
}

// Use a static require/import for bundlers to statically analyze the asset
const reportIncidentImg = require('../../../../assets/reportIncident.png')

export const RetryComponent = ({ onRefresh, textButton, title }: RetryComponentProps) => {
    return (
        <View style={styles.containerNoProducts}>
            <Image style={styles.image} source={reportIncidentImg} />
            <Text style={styles.title}>{title}</Text>
            <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                <Text style={styles.mainButtonTextRetry}>{textButton}</Text>
            </TouchableOpacity>
        </View>
    )
}
